import { render, staticRenderFns } from "./BanckCardManagelist.vue?vue&type=template&id=5280b53a&scoped=true&"
import script from "./BanckCardManagelist.vue?vue&type=script&lang=js&"
export * from "./BanckCardManagelist.vue?vue&type=script&lang=js&"
import style0 from "./BanckCardManagelist.vue?vue&type=style&index=0&id=5280b53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5280b53a",
  null
  
)

export default component.exports